import { EntityModel } from '@/interfaces'
import {
  ALL_EMPLOYEES_QUERY,
  CREATE_EMPLOYEE_MUTATION,
  DELETE_EMPLOYEE_MUTATION,
  FORCE_DELETE_EMPLOYEE_MUTATION,
  SINGLE_EMPLOYEE_QUERY,
  UPDATE_EMPLOYEE_MUTATION,
} from './graphql'
import mediaFileEntity from '@/entities/mediaFile/entity'

const employeeModel: EntityModel = {
  name: 'employee',
  namePlural: 'employees',
  uniqueName: 'employee',
  uniqueNamePlural: 'employees',
  path: 'cms/employee',
  baseUrl: '/cms/employees',
  translationPrefix: 'entities:employee.',
  getDisplayName: (values: any) => {
    return `${values.firstName} ${values.lastName}`
  },
  gql: {
    getAll: ALL_EMPLOYEES_QUERY,
    getSingle: SINGLE_EMPLOYEE_QUERY,
    create: CREATE_EMPLOYEE_MUTATION,
    update: UPDATE_EMPLOYEE_MUTATION,
    delete: DELETE_EMPLOYEE_MUTATION,
    forceDelete: FORCE_DELETE_EMPLOYEE_MUTATION,
  },
  attributes: {
    firstName: {
      name: 'firstName',
      label: 'entities:employee.attributes.firstName.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    lastName: {
      name: 'lastName',
      label: 'entities:employee.attributes.lastName.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    jobTitle: {
      name: 'jobTitle',
      label: 'entities:employee.attributes.jobTitle.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    description: {
      name: 'description',
      label: 'entities:employee.attributes.description.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'textarea',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    email: {
      name: 'email',
      label: 'entities:employee.attributes.email.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'email',
        },
      ],
    },
    image: {
      name: 'image',
      label: 'entities:employee.attributes.image.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return mediaFileEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
    phone: {
      name: 'phone',
      label: 'entities:employee.attributes.phone.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
  },
}

export default employeeModel
